<template>
    <Transition name="popup">
        <ProjectEdit
            v-if="edit.status"
            :p_id="edit.project"
            @click_back="editPageBack"
            @click_save="editPageSave"
        />
    </Transition>
    <Transition name="noti">
        <NotificationCMS 
            v-if="noti.status"
            :tekst="noti.tekst"
            :icon="noti.icon"
        />
    </Transition>
    <Transition name="popup">
        <WarningComp 
            v-if="alert.status"
            :titel="alert.titel"    
            :tekst="alert.tekst"
            :btn1="alert.btn1"
            :btn2="alert.btn2"
            @actionWarning1="waringAction1"
            @actionWarning2="waringAction2"
        />
    </Transition>
    <PagesHeading 
        :titel="$props.titel"
        :zoek="$props.zoek"
        :button="$props.button"
        @click_new="addPage"
        @zoek_item="zoekItem"
        @zoek_stop="zoekStop"
    />
    <div v-if="filteren" class="pages__projects">
        <ProjectCard 
            v-for="project in filterProjects" 
            :key="project"
            :titel="project.titel"
            :img="project.img"
            :projectID="project.id"
            @click_del="warningDel"
            @click_edit="editPage"
        />
    </div>
    <div v-if="filteren == '404'" class="nothingFound">
        <NothingFound />
    </div>
    <div v-if="!filteren" class="pages__projects">
        <ProjectCard 
            v-for="project in projects" 
            :key="project"
            :titel="project.titel"
            :img="project.img"
            :projectID="project.id"
            @click_del="warningDel"
            @click_edit="editPage"
        />
    </div>
    <div v-if="this.projects.length == 0 && filteren != '404'" class="nothingFound">
        <NoResults 
            :naam="'projecten'"
        />
    </div>
</template>
<script>

// TEMPLATES
import axios from 'axios';
import NotificationCMS from '../NotificationCMS.vue';
import WarningComp from '../WarningComp.vue';
import ProjectCard from './_templates/cards/ProjectCard.vue';
import ProjectEdit from './_templates/ProjectEdit.vue';
import PagesHeading from './_templates/comps/PagesHeading.vue'
import NothingFound from './_templates/comps/NothingFound.vue'
import NoResults from './_templates/comps/NoResults.vue'

// FERRUM
export default {
    inject:['data', 'status', 'user', 'appSettings'],
    props:['titel', 'zoek', 'button'],
    components:{
        ProjectCard,
        WarningComp,
        NotificationCMS,
        ProjectEdit,
        PagesHeading,
        NothingFound,
        NoResults,
    },
    data(){
        return{
            projects: [],
            filterProjects: [],
            filteren: false,
            selected: "",
            search: "",
            settings: this.appSettings,
            edit:{
                status: false,
                project:""
            },
            alert: {
                status: false,
                titel: "",
                tekst: "",
                btn1: "",
                btn2: ""
            },
            noti: {
                status: false,
                tekst: "",
                icon: ""
            }
        }
    },
    created(){
        this.getData();
        setTimeout(()=>{
            if(this.$route.query.new == "true"){
                this.$router.replace('/pages')
                this.addPage();
            }
        }, 700);
        setTimeout(()=>{
            if(this.$route.query.edit == "true"){
                this.$router.replace('/pages')
                this.editPage(this.$route.query.id)
                this.$router.replace('/pages')
            }
        }, 700);
        setTimeout(()=>{
            if(this.$route.query.delete == "true"){
                this.$router.replace('/pages')
                this.warningDel(this.$route.query.id)
                this.$router.replace('/pages')
            }
        }, 700);
    },
    methods:{
        zoekItem(x){
            if(x == "refresh"){
                this.filterProjects = [];
                if(this.search.trim() !== ""){
                    for(let i = 0; i < this.projects.length; i++){
                        if(this.projects[i].titel.slice(0, x.length).toLowerCase() == this.search.toLowerCase()){
                            this.filterProjects.push(this.projects[i]);
                            this.filteren = true
                        }
                    }
                    if(this.filterProjects.length == 0){
                        this.filteren = "404"
                    }
                } else{
                    this.filteren = false;
                }
            } else {
                this.search = x;
                this.filterProjects = [];
                if(this.search.trim() !== ""){
                    for(let i = 0; i < this.projects.length; i++){
                        if(this.projects[i].titel.slice(0, x.length).toLowerCase() == this.search.toLowerCase()){
                            this.filterProjects.push(this.projects[i]);
                            this.filteren = true
                        }
                    }
                    if(this.filterProjects.length == 0){
                        this.filteren = "404"
                    }
                } else{
                    this.filteren = false;
                }
            }
        },
        zoekStop(){
            this.search = "";
            this.filteren = false;
        },
        async getData(){
            let data;
            await axios.get(this.status.api + '/get/projects.php',{ 
                params:{ 
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                }
                }).then(function(response){
                        data = response.data;          
                }).catch(function(error){ 
                    console.log(error);
            });
            this.projects = data;
        },  
        addPage(){
            this.edit = {
                status: true,
                project:""
            }
        },
        editPage(x){
            this.edit = {
                status: true,
                project: x
            }
        },
        editPageBack(){
            this.edit = {
                status: false,
                project:""
            }
        },
        async editPageSave(x){
            await this.getData();
            this.zoekItem("refresh");
            let notiTekst;
            let icon;
            if(x === "new"){
                notiTekst = "Project is succesvol toegevoegd";
                icon = "add"
            } else if(x === "edit"){
                notiTekst = "Project is succesvol bijgewerkt";
                icon = "edit"

            }
            this.edit = {
                status: false,
                project:""
            }
            setTimeout(()=>{
                this.noti = {
                    status: true,
                    tekst: notiTekst,
                    icon: icon
                }
            }, 1000);
            setTimeout(()=>{
                this.noti = {
                    status: false,
                    tekst: "",
                    icon: ""
                }
            }, 5000)
        },
        warningDel(x){
            for(let i = 0; i < this.projects.length; i++){
                if(this.projects[i].id === x){
                    let titel = this.projects[i].titel
                    this.selected = x
                    this.alert = {
                        status: true,
                        titel: titel + " verwijderen?",
                        tekst: 'Weet u zeker dat u "' + titel + '" wil verwijderen? Deze actie kan niet ongedaan gemaakt worden.',
                        btn1: "verwijderen",
                        btn2: "terug"
                    }
                }
            }
        },
        async waringAction1(x){
            let data;
            if(x == "verwijderen"){
                await axios.post(this.status.api + '/delete/delete-project.php', {
                    server: this.status.api,
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                    id: this.selected
                }, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(function (response) {
                    if(response.status == 200){
                        data = true
                    }
                }).catch(function (error) {
                    console.error(error);
                }); 
                if(data){
                    this.alert = {
                        status: false,
                        titel: "",
                        tekst: "",
                        btn1: "",
                        btn2: ""
                    }
                    await this.getData();
                    this.zoekItem("refresh");
                    setTimeout(()=>{
                        this.noti = {
                            status: true,
                            tekst: "Project is succesvol verwijderd",
                            icon: "delete"
                        }
                        }, 1000);
                        setTimeout(()=>{
                            this.noti = {
                                status: false,
                                tekst: "",
                                icon: "",
                            }
                        }, 5000)
                    }
                }
        },
        waringAction2(){
            this.alert = {
                status: false,
                titel: "",
                tekst: "",
                btn1: "",
                btn2: ""
            }
        }
    },
    watch:{
        user: {
        handler(x){
            if(x.status){
                this.getData();
            }
        },
        deep: true
        },
    }
    
}
</script>